var $8d0169b475eeaeae$exports = {};
$8d0169b475eeaeae$exports = {
    "pending": `oczekuj\u{105}ce`
};


export {$8d0169b475eeaeae$exports as default};
//# sourceMappingURL=pl-PL.mjs.map
